import { createContext, useContext } from "react";

export type Theme = "light" | "dark";

type ThemeContextType = {
  theme: Theme;
  updateTheme: (Theme: Theme) => void;
};

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined
);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
